module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Products Calculator","remove":"Remove","total":"Total"},"pt-BR":{"title":"Calculadora de Produtos","remove":"Remover","total":"Total"}}')
  delete Component.options._Ctor
}
